<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { vdrActions, fleetsActions } from '@state/helpers';
import ActivitiesInput from './activitiesInput.vue';
import moment from "moment";

/**
 * Starter component
 */
export default {
  page: {
    title: 'Starter',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, ActivitiesInput },
  data() {
    return {
      selectedCategoryOwnership: 'all',
      title: 'Activities',
      vdrList: [],
      visibleFO: true,
      tempFO: null,
      consumptionFO: '',
      receivedFO: 0,
      transferredFO: 0,
      dateRange: [new Date(2021, 5, 1), new Date(2021, 5, 30)],
      selectedFleetEquipment: [],
      fleetEquipmentList: [],
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Activities',
          active: true,
        },
      ],
      categoryOwnership: [
        { value: '', text: 'All Category Ownership' },
        { value: 'owned', text: 'OWNED' },
        { value: 'chartered', text: 'CharterCHARTEREDed' }
      ],
      vehicle: [
        {
          label: 'AWB (Accomodation Work Barge)',
          checked: true,
          disabled: false
        },
        {
          label: 'DSV (Diving Support Vessel)',
          checked: true,
          disabled: false
        },
        {
          label: 'AHTS (Anchor Handling Tug Supply)',
          checked: true,
          disabled: false
        }
      ],
      filterData: {
        dateRange: [],
        page: 1,
        vehicleOwnership: '',
        vehicleIds: [],
      },
      isFetching: true,
      vehicleDetailData: null,
      isSidebarOpen: false,
      modeEdit: false
    }
  },
  mounted() {
    this.initFilterDateRange();
    this.getVehicleTypeList();
    this.getVDRList();
  },
  methods: {
    ...vdrActions,
    ...fleetsActions,
    async getVDRList() {
      this.isFetching = true;
      let params = {
          startDate: moment(this.filterData.dateRange[0]).format('DD-MM-YYYY'),
          endDate: moment(this.filterData.dateRange[1]).format('DD-MM-YYYY'),
          page: this.filterData.page,
          vehicleOwnership : this.filterData.vehicleOwnership,
        }
        if (this.filterData.vehicleIds.length > 0) {
            params.vehicleIds = []
            this.filterData.vehicleIds.forEach(el => {
              params.vehicleIds.push(el.code)
            })
            params.vehicleIds = params.vehicleIds.toString()
        }
        if (this.filterData.vehicleOwnership === '') {
          delete params.vehicleOwnership
        }
        const res = await this.getVDR(params)
        if (res.status == 'success') {
          if(res.data && res.data.length > 0) {
            res.data.forEach(el => {
              this.vdrList.push(el);
            });
            this.vdrList.forEach((element, i) => {
              this.getVDRbyVehicleList(element.id, i)
            });
          }
          this.isFetching = false;
        } else {
          if (this.filterData.page === 1) {
            vdrList = []
          }
          this.$swal(
            `Oops!`,
            res.data,
            'error'
          )
          this.isFetching = false;
        }
    },
    async getVDRbyVehicleList(vehicleId, vdrIdx, pageData = 1) {
      let params = {
          startDate: moment(this.filterData.dateRange[0]).format('DD-MM-YYYY'),
          endDate: moment(this.filterData.dateRange[1]).format('DD-MM-YYYY'),
          page: pageData,
        }
        const res = await this.getVDRbyVehicle({params, vehicleId})
        if (res.status == 'success') {
          if(res.data && res.data.length > 0) {
            this.vdrList[vdrIdx].vdrActivity.data = res.data[0].vdrActivity ? res.data[0].vdrActivity.data : [];
            console.log(res, 'sdf')
          }
        } else {
          vdrList = []
          this.$swal(
            `Oops!`,
            res.data,
            'error'
          )
        }
    },
    async getVehicleTypeList() {
      let params = {
          active: true,
        }
        const res = await this.getFleetTypes({params})
        if (res.status == 'success') {
          if(res.data && res.data.length > 0) {
            
            res.data.forEach(el => {
              this.fleetEquipmentList.push({
                name : el.name,
                code : el.id,
              })
            })
          }
        } else {
          this.$swal(
            `Oops!`,
            res.data,
            'error'
          )
        }
    },
    async getVehicleDetail(dataVal, id) {
      let data = {
          vehicleId: dataVal.id,
          id: id,
        }
        const res = await this.getVDRbyVehicleDetail(data)
        if (res.status == 'success') {
          this.vehicleDetailData = res.data;
          this.vehicleDetailData.name = dataVal.name;
          this.vehicleDetailData.vehicleId = dataVal.id;
          console.log(this.vehicleDetailData)
          this.isSidebarOpen = true;
        } else {
          this.vehicleDetailData = null;
          this.$swal(
            `Oops!`,
            res.data.message,
            'error'
          )
        }
    },
    onBlurNumberConsumptionFO (e) {
      this.visibleFO = false
      this.tempFO = this.counsumptionFO
      this.counsumptionFO = this.thousandSeparator(this.counsumptionFO)
    },
    onFocusTextConsumptionFO () {
      this.visibleFO = true
      this.counsumptionFO = this.tempFO
    },
    thousandSeparator (amount) {
      if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        return amount
      }
    },
    initFilterDateRange () {
      var date = new Date(); var y = date.getFullYear(); var m = date.getMonth()
      var firstDay = new Date(y, m, 1)
      var lastDay = new Date(y, m + 1, 0)

      this.filterData.dateRange = [firstDay, lastDay]
    },
    async onDeleteActivity (vehicleId, activityData, name) {
      let data = activityData

      this.$swal({
        title: 'Delete Vehicle?',
        text: `Vehicle ${name} will be deleted and cannot be recovered.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete'
      }).then(async (result) => {
        if (result.isConfirmed) {
          let res = await this.deleteVDRbyVehicle({ vehicleId: vehicleId, id: data.id })
          if (res.status != 'success') {
            if (res.data.message != null) {
              this.$swal('Error', res.data.message, 'error')
            } else {
              this.$swal(
                'Error',
                'Something wrong with the server. Cannot get user data.',
                'error'
              )
            }
          } else {
            this.getVDRList()
            this.isSidebarOpen = false;
            this.$swal(
              `Vehicle deleted!`,
              `Vehicle ${name} successfully deleted`,
              'success'
            )
          }
        }
      })
    },
    async onChangeStatus (vehicleId, activityData, name, status) {
      let data = activityData

      console.log(vehicleId, activityData, name, status)

      this.$swal({
        title: `Change to ${status} status Vehicle?`,
        text: `Vehicle ${name} status will be update .`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'update'
      }).then(async (result) => {
        if (result.isConfirmed) {
          let res = await this.updateStatusVDRbyVehicle({ vehicleId: vehicleId, id: data.id, status : status })
          if (res.status != 'success') {
            if (res.data.message != null) {
              this.$swal('Error', res.data.message, 'error')
            } else {
              this.$swal(
                'Error',
                'Something wrong with the server. Cannot get user data.',
                'error'
              )
            }
          } else {
            this.getVDRList()
            this.isSidebarOpen = false;
            this.$swal(
              `Change Status Success!`,
              `Change ${name} to ${status} status Success`,
              'success'
            )
          }
        }
      })
    },
  },
}
</script>

<template>
  <Layout>
    <!-- Top Section !-->
    <b-row class="mt-4">
      <b-col lg="12">
        <b-card>
          <b-card-title>
            <div class="row">
              <div class="col-md-10">
                <h4 class="card-title"><strong>VESSEL DAILY REPORT (VDR)</strong></h4>
              </div>
              <div class="col-md-2 float-right">
                <a v-b-toggle.collapse-filter class="text-primary float-right" role="button" style="cursor: pointer;">
                  <feather type="filter" class="icon-dual"></feather>
                </a>
              </div>
            </div>
          </b-card-title>
          <b-card-text>
            <b-collapse id="collapse-filter" visible>
              <b-row>
                <!-- <b-col md="4">
                  <b-form-group label="Category:" label-for="kind-fleet">
                    <template v-for="(item,index) in vehicle">
                      <b-form-checkbox :key="index" v-model="item.checked" :disabled="item.disabled" name="check-button" switch inline>
                        {{ item.label }}
                      </b-form-checkbox>
                    </template>
                  </b-form-group>
                </b-col>-->
                <b-col md="3">
                  <b-form-group label="Fleet/Equipment:" label-for="fleet-equipment">
                    <v-multiselect v-model="filterData.vehicleIds" tag-placeholder="Category" placeholder="Search or add a category" label="name" track-by="code" :options="fleetEquipmentList" :multiple="true" :taggable="true">
                    </v-multiselect>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label-for="dateIssued" label="Category Ownership">
                    <b-form-select id="gender" v-model="filterData.vehicleOwnership" plain :options="categoryOwnership">
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label-for="dateIssued" label="Report Date">
                  <date-picker class="w-100"
                    v-model="filterData.dateRange"
                    type="date"
                    range
                    :placeholder="`Select date`"
                  ></date-picker>
                  </b-form-group>
                </b-col>
                <b-col md="1">
                  <b-form-group label="Filter" label-for="button_search">
                    <b-button @click="getVDRList()" size="sm" class="btn btn-soft-info mb-3 mr-1"><feather type="filter" class="icon-dual"></feather></b-button>
                  </b-form-group>
                </b-col>
                <b-col md="3" class="text-right">
                  <!-- <router-link to="/ops/export-certificate">
                    <b-button variant="dark" class="mr-1"><i class="fa fa-file-excel"></i> Export</b-button>
                  </router-link> -->
                  <b-button
                      v-b-modal.add-vdr
                      variant="success"
                      class="mr-1 mt-4"><i class="fa fa-plus"></i> ADD VDR
                  </b-button>
                  <b-modal
                      id="add-vdr"
                      size="xl"
                      :title="modeEdit ? 'Edit' : 'Add' +  ' Vessel Daily Report'"
                      ok-title="Submit"
                      no-close-on-backdrop
                      hide-footer>
                      <ActivitiesInput 
                      v-bind:formData="vehicleDetailData" 
                      v-bind:isEdit="modeEdit" 
                      @childAction="modeEdit = false; $bvModal.hide('add-vdr');"/>
                  </b-modal>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <!-- End Top Section !-->
    <!-- Content Section !-->
    <b-row>
      <!-- Card Fleet -->
      <b-col md="12">
        <b-card class="iq-mb-3" v-for="(each, i) in vdrList" :key="i">
          <b-card-text>
            <b-row>
              <b-col sm="3">
                <b-card class="iq-mb-3">
                  <b-card-text>
                    <div class="top3">
                      <div class="boat2"><img :src="each.img ? each.img.url : require('../../../../assets/images/fleet/dsv.png')" :alt="each.img ? each.img.iconName : ''"></div>
                      <div class="waves2"></div>
                    </div>
                    <div class="bottom">
                      <div class="float"></div>
                    </div>
                  </b-card-text>
                  <b-card-text><a href="#"><h4 class="mb-3 text-center text-danger"><b>{{each.name}}</b></h4></a></b-card-text>
                </b-card>
              </b-col>
              <b-col sm="9">
                <table class="table table-striped" :id="'my-table'+each.id">
                  <thead>
                  <tr>
                    <th>No</th>
                    <th>Date</th>
                    <th>Total Time Daily</th>
                    <th>Chartered</th>
                    <!-- <th>On Hire</th> -->
                    <!-- <th>Off Hire</th> -->
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(dataVal, j) in each.vdrActivity.data" :key="j" v-if=" each.vdrActivity.data &&  each.vdrActivity.data.length > 0">
                    <td>{{j+1}}</td>
                    <td>
                      <!-- <router-link to="" v-b-toggle.sidebar-view>August 10, 2021</router-link> -->
                      {{dataVal.date || '-'}}
                    </td>
                    <td>{{dataVal.durationFormat || '-'}} Hours</td>
                    <td>{{dataVal.chartered || '-'}}</td>
                    <!-- <td>July 25, 2021</td>
                    <td>December 25, 2021</td> -->
                    <td>
                      <b-dropdown variant="warning">
                        <template slot="button-content">
                          {{dataVal.status || '-'}}
                          <i class="uil uil-angle-down"></i>
                        </template>
                        <b-dropdown-item :disabled="true">Activity Status</b-dropdown-item>
                        <b-dropdown-item v-if="dataVal.status === 'DRAFT' || dataVal.status === null"><b-button @click="onChangeStatus(each.id, dataVal, each.name, 'review')" class="mb-1" block variant="primary" ref="button">Review</b-button></b-dropdown-item>
                        <b-dropdown-item v-if="dataVal.status === 'REVIEW'"><b-button @click="onChangeStatus(each.id, dataVal, each.name, 'approve')"  class="mb-1" block variant="success" ref="button">Approved</b-button></b-dropdown-item>
                      </b-dropdown>
                    </td>
                    <td>
                      <b-dropdown variant="primary">
                        <template slot="button-content">
                          Action
                          <i class="uil uil-angle-down"></i>
                        </template>
                        <b-dropdown-item @click="getVehicleDetail(each, dataVal.id)"><i class="fa fa-list"></i> View / Edit</b-dropdown-item>
                        <b-dropdown-item @click="onDeleteActivity(each.id, dataVal, each.name)"><i class="fa fa-trash"></i> Delete</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div class="d-flex justify-content-center">
                  <b-pagination
                    @change="getVDRbyVehicleList(each.id, i, i+1)"
                    v-model="each.vdrActivity.currentPage"
                    :total-rows="each.vdrActivity.total"
                    :per-page="each.vdrActivity.perPage"
                    :aria-controls="'my-table'+each.id"
                  ></b-pagination>
                </div>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
      <b-col md="12" class="text-center">
        <b-button @click="filterData.page+=1; getVDRList();" variant="warning" size="lg" class="justify-content-center"><span v-if="isFetching"><i class="fas fa-spinner fa-pulse"></i></span> Load More</b-button>
      </b-col>
      <!-- END Card Fleet -->
    </b-row>
    <!-- END Content Section !-->

<b-sidebar
    v-model="isSidebarOpen"
    v-if="vehicleDetailData"
    id="sidebar-view"
    :title="'View Vessel Daily Report -' + vehicleDetailData.name"
    width="800px"
    backdrop-variant="dark"
    right
    backdrop
    shadow>
  <b-row class="pt-2 pl-3 pr-3 pb-2" >
    <b-col md="10">
      <table class="table table-striped">
        <tbody>
        <tr>
          <td width="25%">Date</td>
          <td width="5%">:</td>
          <td><strong>{{vehicleDetailData.date}}</strong></td>
          <td width="25%" class="pl-5">Status</td>
          <td width="5%">:</td>
          <td><b-badge variant="warning">{{vehicleDetailData.status}}</b-badge></td>
        </tr>
        <tr>
          <td width="25%">Current Location</td>
          <td width="5%">:</td>
          <td><strong>{{vehicleDetailData.port.portName}}</strong></td>
          <td width="25%" class="pl-5">Total Time Daily</td>
          <td width="5%">:</td>
          <td><strong>{{vehicleDetailData.durationFormat}}</strong></td>
        </tr>
        <tr>
          <td width="25%">Chartered</td>
          <td width="5%">:</td>
          <td><strong>{{vehicleDetailData.subProject.name}}</strong></td>
          <!-- <td width="25%" class="pl-5">Long Lat</td>
          <td width="5%">:</td>
          <td><strong>-6.200000 , 106.816666</strong></td> -->
        </tr>
        </tbody>
      </table>
    </b-col>
    <b-col md="2" class="text-right pt-2">
      <b-dropdown size="sm" text="Small" right>
        <template slot="button-content">
          <i class="fa fa-ellipsis-h"></i>
        </template>
        <b-dropdown-item v-b-toggle.sidebar-view @click="modeEdit = true; $bvModal.show('add-vdr');"><i class="fa fa-edit"></i> Edit</b-dropdown-item>
        <b-dropdown-item v-if="vehicleDetailData.status === 'DRAFT' || vehicleDetailData.status === null"  @click="onChangeStatus(vehicleDetailData.vehicleId, vehicleDetailData, vehicleDetailData.name, 'review')"><i class="fa fa-check text-success"></i> Review</b-dropdown-item>
        <b-dropdown-item v-if="vehicleDetailData.status === 'REVIEW'"  @click="onChangeStatus(vehicleDetailData.vehicleId, vehicleDetailData, vehicleDetailData.name, 'approve')"><i class="fa fa-check text-success"></i> Approve</b-dropdown-item>
        <!-- <b-dropdown-item v-b-toggle.sidebar-view><i class="fa fa-times text-danger"></i> Reject</b-dropdown-item> -->
        <b-dropdown-item  @click="onDeleteActivity(vehicleDetailData.vehicleId, vehicleDetailData, vehicleDetailData.name)"><i class="fa fa-trash"></i> Delete</b-dropdown-item>
      </b-dropdown>
    </b-col>
    <b-col md="12" class="mb-3">
      <hr>
      <h5 class="text-center">Weather Condition</h5>
    </b-col>
    <b-col md="12">
      <table class="table table-striped">
        <thead>
        <tr>
          <th width="40%" colspan="2" class="text-center">Weather / Time</th>
          <th width="30%" rowspan="2" class="text-center" style="vertical-align: middle">Wind (Dir/Speed)</th>
          <th width="30%" rowspan="2" class="text-center" style="vertical-align: middle">Visibility</th>
        </tr>
        <tr class="text-center">
          <th>From</th>
          <th>To</th>
        </tr>
        </thead>
        <tbody>
          <template v-if="vehicleDetailData.weathers && vehicleDetailData.weathers.length > 0">
            <tr class="text-center" v-for="(each, j) in vehicleDetailData.weathers" :key="j">
              <td>{{each.timeFrom}}</td>
              <td>{{each.timeEnd}}</td>
              <td>{{each.wind}} Knots</td>
              <td>{{each.visibility}} Nm</td>
            </tr>
          </template>
        <tr v-if="vehicleDetailData.weathers.length === 0"><td class="text-center" colspan="8">No Data</td></tr>
        </tbody>
      </table>
    </b-col>
    <b-col md="12" class="mb-3">
      <hr>
      <h5 class="text-center">DAILY LOG ACTIVITIES / VESSEL MOVEMENTS</h5>
    </b-col>
    <b-col md="12">
      <table class="table table-striped table-warning">
        <thead>
        <tr>
          <th width="10%">Time Start</th>
          <th width="10%">Time End</th>
          <th width="30%">Daily Operational Activities</th>
          <th width="25%">Remarks</th>
          <th width="25%">Total Duration</th>
        </tr>
        </thead>
        <tbody>
           <template v-if="vehicleDetailData.logs && vehicleDetailData.logs.length > 0">
            <tr class="text-center" v-for="(each, j) in vehicleDetailData.logs" :key="j">
              <td>{{each.timeFrom}}</td>
              <td>{{each.timeEnd}}</td>
              <td>{{each.reason.name}}</td>
              <td>{{each.remark}}</td>
              <td>{{each.duration}}</td>
            </tr>
          </template>
        <tr v-if="vehicleDetailData.logs.length === 0"><td class="text-center" colspan="8">No Data</td></tr>
        </tbody>
        <!-- <tfoot>
        <tr>
          <th colspan="4">Total</th>
          <th>24:00 Hours</th>
        </tr>
        </tfoot> -->
      </table>
    </b-col>
  </b-row>
  <b-col md="12" class="mb-3">
    <hr>
    <h5 class="text-center">Running Hours</h5>
    <table class="table table-striped table-info">
      <thead>
      <tr>
        <th width="25%">Type of Machine</th>
        <th width="25%">Initial <small>Previous Running Hour</small></th>
        <th width="25%">Running Hours Day</th>
        <th width="25%">Total Running Hours</th>
      </tr>
      </thead>
      <tbody>
        <template v-if="vehicleDetailData.runningHours && vehicleDetailData.runningHours.length > 0">
          <tr class="text-center" v-for="(each, j) in vehicleDetailData.runningHours" :key="j">
            <!-- <td>{{each.timeFrom}}</td>
            <td>{{each.timeEnd}}</td>
            <td>{{each.reason?.name}}</td>
            <td>{{each.remark}}</td>
            <td>{{each.duration}}</td> -->
          </tr>
        </template>
      <tr v-if="vehicleDetailData.runningHours.length === 0"><td class="text-center" colspan="8">No Data</td></tr>
      </tbody>
    </table>
  </b-col>
  <b-col md="12">
    <hr>
    <h5 class="text-center">SUMMARY OF DAILY FUEL, WATER, & CARGOS REMAINING ONBOARD</h5>
    <table class="table table-striped table-primary">
      <thead>
      <tr>
        <th width="15%">Type</th>
        <th width="15%">Opening (ROB From Previous Day)</th>
        <th width="15%">Consumption (Based on Actual Sounding)</th>
        <th width="10%">Received</th>
        <th width="10%">Transferred</th>
        <th width="15%">Closing</th>
        <th width="20%">Remarks</th>
      </tr>
      </thead>
      <tbody>
        <template v-if="vehicleDetailData.robs && vehicleDetailData.robs.length > 0">
          <tr class="text-center" v-for="(each, j) in vehicleDetailData.robs" :key="j">
            <!-- <td>{{each.timeFrom}}</td>
            <td>{{each.timeEnd}}</td>
            <td>{{each.reason?.name}}</td>
            <td>{{each.remark}}</td>
            <td>{{each.duration}}</td> -->
          </tr>
        </template>
        <tr v-if="vehicleDetailData.robs.length === 0"><td class="text-center" colspan="8">No Data</td></tr>
      </tbody>
    </table>
  </b-col>
  <b-col md="12">
    <b-row class="mb-5">
      <b-col md="6">
        <hr>
        <h5 class="text-center">Crew List <b-badge variant="info">1</b-badge> </h5>
        <b-row>
          <b-col md="12">
            <table class="table table-striped table-success">
              <thead>
              <tr>
                <th width="15%">No</th>
                <th width="40%">Name</th>
                <th width="40%">Position</th>
              </tr>
              </thead>
              <tbody>
                <template v-if="vehicleDetailData.crews && vehicleDetailData.crews.length > 0">
                  <tr v-for="(each, j) in vehicleDetailData.crews" :key="j">
                    <td>{{j+1}}</td>
                    <td>{{each.name}}</td>
                    <td>{{each.position}}</td>
                  </tr>
                </template>
                <tr v-if="vehicleDetailData.crews.length === 0"><td class="text-center" colspan="8">No Data</td></tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="6">
        <hr>
        <h5 class="text-center">Passenger List <b-badge variant="success">1</b-badge> </h5>
        <b-row>
          <b-col md="12">
            <table class="table table-striped table-success">
              <thead>
              <tr>
                <th width="15%">No</th>
                <th width="40%">Name</th>
                <th width="40%">Company</th>
              </tr>
              </thead>
              <tbody>
              <template v-if="vehicleDetailData.passengers && vehicleDetailData.passengers.length > 0">
                  <tr v-for="(each, j) in vehicleDetailData.passengers" :key="j">
                    <td>{{j+1}}</td>
                    <td>{{each.name}}</td>
                    <td>{{each.company}}</td>
                  </tr>
                </template>
                <tr v-if="vehicleDetailData.passengers.length === 0"><td class="text-center" colspan="8">No Data</td></tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-col>
</b-sidebar>
  </Layout>
</template>
